<!--
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-19 16:21:52
 * @FilePath: /insuranceagent-ui/src/views/insuranceCenter/pay/payOffline.vue
 * @Description: 
-->
<template>
	<basic-container v-if="configSetting.payTypes" v-loading="isInitLoading" :block="isInitLoading">
		<PayResult
			:insure-type="insureType"
			:is-add="false"
			:is-pay-loading.sync="isPayLoading"
			:order-id="orderId"
			:pay-source="2"
			:pay-types-data="configSetting.payTypes || []"
			:pre-pay-notice-data="configSetting.prePayNotice"
			:product-id="productId"
			:source-product-id="sourceProductId"
			:temp-order-id="orderId"
			:is-close-tag="true"
			:total-price="totalPremium"
			@onPayAgain="onOpenToPay"
			@onToPolicyDetail="onToPolicyDetail"></PayResult>
	</basic-container>
</template>

<script>
import PayResult from '@/views/insuranceCenter/components/payResult'
import {getBaseConfigInfo} from 'meibao-insure/src/api/productCenterNew'
import {dealClearCode} from 'meibao-insure/src/util/commonUtils'
import store from '@/store'
import {MessageEventType, sendMsgToParent} from '@/util/channelUtil'

export default {
	name: 'payOffline',
	components: {
		PayResult,
	},

	data() {
		return {
			insureType: 1,
			isAdd: false,
			isPayLoading: false,
			configSetting: {},
			isInitLoading: true,
		}
	},
	async mounted() {
		//通过config接口获取支付信息
		this.onInitData()
	},
	methods: {
		async onInitData() {
			//http://localhost:8094/#/insuranceCenter/pay/payOffline?flag=2&fromType=pay&act=pay&fromTypeChannel=hekang&orderId=1749524&sourceProductId=528&productId=721&insureType=6&totalPremium=600
			try {
				let {
					act = '',
					fromTypeChannel = '',
					orderId = '',
					sourceProductId = '',
					productId = '',
					insureType = '',
					totalPremium = '',
				} = this.$route.query || {}

				this.sourceProductId = sourceProductId
				this.productId = productId
				this.insureType = insureType
				this.totalPremium = totalPremium
				this.orderId = orderId
				//获取配置信息
				let baseConfig = (await this.onGetBaseConfig()) || {}
				let {setting = {}} = baseConfig
				this.configSetting = setting
			} catch (error) {
				this.$alert(error.message, '提示', {
					confirmButtonText: '确定',
					type: 'warning',
				})
			} finally {
				this.isInitLoading = false
			}
		},
		onOpenToPay() {
			this.isPayLoading = true
		},
		onToPolicyDetail() {
			this.isPayLoading = true
			//判断是否为内嵌，如果是，则发消息
			sendMsgToParent({msgType: MessageEventType.policyDetail, orderId: this.orderId})
		},
		//获取配置信息
		async onGetBaseConfig() {
			//清空
			let headers = {}
			if (this.envConfig.isBxXsm()) {
				headers = dealClearCode(this.insureType, store)
			}
			return await getBaseConfigInfo(this.isAdd, headers, this.productId, this.sourceProductId, this.orderId)
		},
	},
}
</script>
